import { MixinsOptions } from '@mui/material/styles';
import { breakpoints } from '../variables/breakpoints';

export const mixins: MixinsOptions = {
  toolbar: {
    zIndex: 200,
    height: 90,
    [breakpoints.up('lg')]: {
      height: 120,
    },
  },
};
